var initializeBlockAccordion = function(block){
    
    jQuery(".accordion button", block).click(function(){
		
		var currentRow = jQuery(this).parent();
        
        
		jQuery(this).toggleClass("active");
		jQuery('.content', currentRow).slideToggle(300);
        
        if(jQuery('.content', currentRow).attr("aria-expanded") == "false"){
            jQuery('.content', currentRow).attr("aria-expanded", "true");
        } else {
            jQuery('.content', currentRow).attr("aria-expanded", "false");
        }
		
	});
    
}

//initialize each block on front end
jQuery(document).ready(function(){
    jQuery('.wp-block-accordion').each(function(){
        initializeBlockAccordion(jQuery(this));
    });
});

//initialize dynamic block preview in the editor
if(window.acf)
    window.acf.addAction('render_block_preview/type=accordion', initializeBlockAccordion);
